import unixTimeConverter from './unixTimeConverter';

const normalizeOpenWeather = (data) => {

    const toKmPerHour = (metersPerSecond) => {
        return Math.trunc(metersPerSecond * 3.6);
    }

    const newObject = {};

    newObject.current = {};
    newObject.current.temp = Math.trunc(data.current.temp);

    newObject.daily = [];
    data.daily.map((day) => 
        newObject.daily.push(
            {date: unixTimeConverter(day.dt, 'day'),
             date_unix: day.dt,
             tempMin: Math.trunc(day.temp.min),
             tempMax: Math.trunc(day.temp.max),
             iconSrc: `https://openweathermap.org/img/wn/${day.weather[0].icon}@2x.png`,
             wind: toKmPerHour(day.wind_speed),
             rainProb: Math.trunc(day.pop * 100),
             rain: day.rain ? Math.round(day.rain * 10) / 10 : '0.0'
            }
        )
    )

    newObject.hourly = [];
    data.hourly.map((hour) => 
        newObject.hourly.push(
            {hour: unixTimeConverter(hour.dt, 'hour'),
             hour_unix: hour.dt,
             temp: Math.trunc(hour.temp),
             iconSrc: `https://openweathermap.org/img/wn/${hour.weather[0].icon}@2x.png`,
             wind: toKmPerHour(hour.wind_speed),
             rainProb: Math.trunc(hour.pop * 100),
             rain: hour.rain ? Math.round(hour.rain['1h'] * 10) / 10 : '0.0'

            }
        )
    )

    return newObject;
}

export default normalizeOpenWeather;
